import { useState } from "react";
import { Package, LogIn } from "lucide-react";
import NophoneCompose from "./NophoneCompose";
import Image from "next/image";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* HEADER */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#122d67] backdrop-blur-sm border-b border-navy/20">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {/* <div className="w-12 h-12 bg-primary-foreground rounded-full flex items-center justify-center shadow-lg"> */}
            {/* <Package className="w-7 h-7 text-primary" /> */}
            <Image
              src="/logo.jpg"
              alt="logo"
              width={90}
              height={90}
              style={{ borderRadius: 10 }}
            />
            {/* </div> */}
            <a href="/" className="flex items-center gap-2">
              <span className="text-xl font-bold text-primary-foreground">
                Khuleg <span className="text-accent">Cargo</span>
              </span>
            </a>
          </div>

          <nav className="md:flex items-center gap-8">
            {/* 🔵 POPUP OPEN BUTTON */}
            <button
              onClick={() => setOpen(true)}
              className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
            >
              Дугааргүй ачаа шалгах
            </button>

            <nav className="hidden md:flex items-center gap-8">
              <a
                href="#services"
                className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Үйлчилгээ
              </a>
              <a
                href="#calculator"
                className="text-primary-foreground/90 text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Тооцоолуур
              </a>
              <a
                href="#contact"
                className="text-primary-foreground/90  text-sm hover:text-primary-foreground transition-colors font-bold"
              >
                Холбоо барих
              </a>
            </nav>

            {/* 🟡 НЭВТРЭХ (харилцагчийн булан) */}
            <a
              href="/track"
              className="flex items-center gap-1.5 bg-accent text-accent-foreground text-sm font-bold px-4 py-2 rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              <LogIn className="w-4 h-4" />
              Нэвтрэх
            </a>
          </nav>
        </div>
      </header>

      {/* POPUP COMPONENT */}
      <NophoneCompose open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Header;
